import React from 'react'

import { SORT_BY } from 'Pods/SearchPage/Store/constants'

const SORT_LABEL_KEYS = [
  [SORT_BY.BEST_MATCH, 'best_match'],
  [SORT_BY.TOP_SELLING, 'top_sellers'],
  [SORT_BY.NEWEST, 'newest'],
  [SORT_BY.OLDEST, 'oldest'],
  [SORT_BY.LOWEST_PRICE, 'lower_price'],
  [SORT_BY.HIGHEST_PRICE, 'higher_price'],
  [SORT_BY.TRENDING, 'trending'],
]

// Built per render rather than at module scope: the labels are locale-dependent and the i18next
// singleton never leaves lng 'en', so they must be resolved through the page's useTranslate.
export const buildSortingFiltersConfig = translate => [{
  label: null,
  filters: SORT_LABEL_KEYS.map(([value, key]) => ({
    value,
    label: translate(`search_page.filters.sorting.${key}`),
    count: value === SORT_BY.BEST_MATCH
      ? <span className="cgt-caption">{translate('search_page.filters.sorting.default_option')}</span>
      : undefined,
  })),
}]
